var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderManageApprovedDashBoard", {
        class: { "fix-element-to-top": _vm.fixElement },
        attrs: {
          fixElement: _vm.fixElement,
          pagingObj: _vm.pagingObj,
          eventStatus: _vm.tableType,
          sliderValue: _vm.sliderValue,
          textSearch: _vm.textSearch,
          listChecked: _vm.dataSort,
          "list-filtered": _vm.dataFilter
        },
        on: {
          TEXT_SEARCH_CHANGE: _vm.handleTextSearchChange,
          CHANGE_FILTER_OPTION: _vm.handleChangeDataSort,
          CHANGE_FILTER_STATUS_OPTION: _vm.handleChangeDataFilter,
          SLIDER_CHANGE_VALUE: _vm.handleSliderChangeValue
        }
      }),
      _vm._v(" "),
      _c("div", {
        style: { height: _vm.fixElement ? _vm.getHeightOfComp + "px" : "0px" }
      }),
      _vm._v(" "),
      _c("Manage", {
        ref: "listEventByClients",
        attrs: {
          loading: _vm.getLoading,
          dateOut: _vm.sliderValue,
          filterBy: _vm.dataFilter,
          sortBy: _vm.dataSort,
          textSearch: _vm.textSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0b510c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0b510c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/ManageApproved.vue
// module id = 1794
// module chunks = 1